function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62214 8.99913H2.82271C1.94281 8.99913 1.2229 8.27922 1.2229 7.39932V3.3998C1.2229 2.5199 1.94281 1.79999 2.82271 1.79999H7.62214C8.50203 1.79999 9.22195 2.5199 9.22195 3.3998V7.39932C9.22195 8.27922 8.50203 8.99913 7.62214 8.99913Z",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.22217 1V2.59981",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.22266 1V2.59981",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.22271 4.99979C3.44359 4.99979 3.62266 4.82073 3.62266 4.59984C3.62266 4.37895 3.44359 4.19989 3.22271 4.19989C3.00182 4.19989 2.82275 4.37895 2.82275 4.59984C2.82275 4.82073 3.00182 4.99979 3.22271 4.99979Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.22222 4.99955C7.44311 4.99955 7.62217 4.82049 7.62217 4.5996C7.62217 4.37871 7.44311 4.19965 7.22222 4.19965C7.00133 4.19965 6.82227 4.37871 6.82227 4.5996C6.82227 4.82049 7.00133 4.99955 7.22222 4.99955Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.22246 4.99955C5.44335 4.99955 5.62241 4.82049 5.62241 4.5996C5.62241 4.37871 5.44335 4.19965 5.22246 4.19965C5.00157 4.19965 4.82251 4.37871 4.82251 4.5996C4.82251 4.82049 5.00157 4.99955 5.22246 4.99955Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M3.22271 6.99937C3.44359 6.99937 3.62266 6.8203 3.62266 6.59942C3.62266 6.37853 3.44359 6.19946 3.22271 6.19946C3.00182 6.19946 2.82275 6.37853 2.82275 6.59942C2.82275 6.8203 3.00182 6.99937 3.22271 6.99937Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.22222 6.99937C7.44311 6.99937 7.62217 6.8203 7.62217 6.59942C7.62217 6.37853 7.44311 6.19946 7.22222 6.19946C7.00133 6.19946 6.82227 6.37853 6.82227 6.59942C6.82227 6.8203 7.00133 6.99937 7.22222 6.99937Z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M5.22246 6.99937C5.44335 6.99937 5.62241 6.8203 5.62241 6.59942C5.62241 6.37853 5.44335 6.19946 5.22246 6.19946C5.00157 6.19946 4.82251 6.37853 4.82251 6.59942C4.82251 6.8203 5.00157 6.99937 5.22246 6.99937Z",
  fill: "currentColor"
});

function SvgCalendaricon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendar.icon.6e251fae.svg";
export { ForwardRef as ReactComponent };